<template>
  <div class="top">
    <b-container fluid="true" class="itemContainer">
      <div :class="{seasonHeader: item.typeCode === 1, signatureHeader: item.typeCode === 0}">
        <b-row>
          <p class="pkgNameText">{{ item.type }}</p>
        </b-row>
      </div>
      <b-card class="p-2 itemImage" :img-src="item.thumbnail" img-alt="Image" @load="onload">
        <b-card-title>
          <div class="itemTitle">
            <div>[ {{ item.type }} ]</div>
            <div>
              <strong>{{ item.title }}</strong>
            </div>
          </div>
        </b-card-title>
        <b-card-text>
          <div class="font-weight-bold mb-3">{{ item.date }}</div>
          <div class="h5" v-html="cvtCrToBr(item.price)"></div>
          <div class="rowSpace"></div>
          <router-link :to="`/p/DiningPromotionDetail/${item.id}`">
            <a @click="goDetail(item)">
              <div class="moreText">More <arrow-right-icon class="fea icon-sm" /></div>
            </a>
          </router-link>

          <!--          <router-link :to="`/p/DiningPromotionDetail/${item.id}`">-->
          <!--            <div class="moreText">More <arrow-right-icon class="fea icon-sm" /></div>-->
          <!--          </router-link>-->
        </b-card-text>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import {ArrowRightIcon} from 'vue-feather-icons';
import GeneralUtil from '@/util/GeneralUtil';
export default {
  name: 'DiningPromotionItem',
  mixins: [GeneralUtil],
  components: {ArrowRightIcon},
  props: {
    item: {
      type: Object,
    },
    showSignatureMode: Boolean,
  },
  data() {
    return {
      price: 0,
    };
  },

  mounted() {
    console.log('HEIGHT>>>!!!1-CHILD-MOUNT');
    this.price = new Intl.NumberFormat('ko-KR', {style: 'currency', currency: 'KRW'}).format(this.item.price);
    console.log('DINNING', this.item);
  },
  methods: {
    onload() {
      console.log('HEIGHT>>>!!!1-CHILD-ONLOAD');
      this.$emit('ImgLoaded');
    },
    goDetail(item) {
      console.log('------------------');
      console.log(item);
      this.$router.push({
        params: {
          id: item.id,
        },
      });
      // this.$router.push({item: JSON.stringify(item)});
    },
  },
};
</script>

<style scoped lang="scss">
.top {
}

@mixin ellipsis($line-cnt, $line-height) {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: $line-cnt; /* 라인수 */
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  word-break: normal;
  line-height: $line-height;
  height: ($line-height * $line-cnt); /* line-height 가 1.2em 이고 3라인을 자르기 때문에 height는 1.2em * 3 = 3.6em */
}

.seasonHeader {
  margin-top: 1px;
  margin-right: 2px;
  position: absolute;
  right: 0;
  background-color: #182957;
  width: 35%;
  height: 7%;
  margin-bottom: 0%;
  z-index: 10;
}

.signatureHeader {
  margin-top: 1px;
  margin-right: 2px;
  position: absolute;
  right: 0;
  background-color: #bd8562;
  width: 35%;
  height: 7%;
  z-index: 10;
}

.pkgNameText {
  position: absolute;
  text-align: center;
  color: white;
  font-size: 0.7em;
  font-weight: bold;
  white-space: nowrap;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}
.moreText {
  color: #937348;
}
.rowSpace {
  height: 1rem;
}
.itemTitle {
  @include ellipsis(2, 1.2em);
  position: relative;
  color: black;
  font-size: 1rem !important;
  font-weight: bolder;
}
.itemImage {
  img {
    object-fit: cover;
  }
}
@media (min-width: 992px) {
  .itemImage {
    img {
      height: 15rem;
    }
  }
}
@media (min-width: 768px) and (max-width: 992px) {
  .itemImage {
    img {
      height: 25rem;
    }
  }
}
@media (max-width: 768px) {
  .itemImage {
    img {
      height: 20rem;
    }
  }
}
</style>
